import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useGlobal from '../../../store';
import BalkonRow from '../../components/balkon.row';
import Button from '../../components/button';
import CompanyStats from '../../components/company.stats';
import Container from '../../components/container';
import Loading from '../../components/loading';
import Selectfield from '../../components/selectfield';
import ToggleSlider from '../../components/toggleslider';
import TariffGate from '../../components/tariff.gate';
import { accessLevel, featureAllowed } from '../../../settings/tariff.features';
import { tariffStatusText } from '../../../store/actions/tariff';
import './main.page.scss';

const Main = () => {

  const navigate = useNavigate();
  const openConstructor = () => { navigate('/constructor'); };

  const [ globalState, globalActions ] = useGlobal();
  const { 

    user_id, 
    user_role,
    tariff,
    balkons, 
    balkons_filter, 
    balkons_filter_archieve,
    balkons_has_archived,
    employees, 
    balkonsIsLoaded 

  } = globalState;

  const { balkon, global, changeStates } = globalActions;

  const [ filterByEmployee, setFilterByEmployee ] = useState( employees[ 0 ] );

  const employeeCount = employees.filter( el => +el.id > 0 ).length;
  const showEmployeeFilter = +user_role < 3 && employeeCount > 1;
  const showArchiveFilter = balkons_has_archived || balkons_filter_archieve === 1;
  const projectsOpen = !!user_id && featureAllowed(accessLevel(tariff), 'projects');
  const showStats = Number(user_role) === 1 || Number(user_role) === 2;

  useEffect(() => {

    if (!projectsOpen) return;
    global.get();

  }, [ projectsOpen ]);
  
  useEffect(() => { 
    
    if (!projectsOpen) return;
    balkon.all();
  
  }, [ projectsOpen, balkons_filter, balkons_filter_archieve, filterByEmployee ]);
  
  return (

    <Container className="projects">

      <p className = "projects__tariff">{ tariffStatusText(tariff) }</p>

      <hr />

      { showStats && (

        <TariffGate feature = "stats" mode = "inline">

          <CompanyStats />

        </TariffGate>

      )}

      <hr />

      <TariffGate feature = "projects" mode = "inline">

      <Button

        text = "+ Новый балкон"
        action = { () => {
          
          balkon.resetProjectStates();
          navigate('/new/1');
        
        }}

      />

      <hr />

      { showEmployeeFilter &&
      
        <React.Fragment>

          <ToggleSlider

            title = "Отображать проекты:"
            list = {[ "все", "только мои", "сотрудников" ]}
            selected = { balkons_filter }
            select = { ( v ) => { 
              
              let newState = { balkons_filter: v }
              if ( balkons_filter === 2 ) { newState.balkons_filter_employee = 0; }
              changeStates( newState ) 
            
            }}

          />

          { balkons_filter === 2 &&
          
            <Selectfield

              title = "Cотрудник:"
              selected = { filterByEmployee }
              select = { ( obj ) => {

                setFilterByEmployee( obj );
                changeStates({ balkons_filter_employee: obj.id })

              }}
              list = { employees }
              style = {{ marginTop: '20px' }}
            
            />
          
          }

        </React.Fragment>

      }

      { showArchiveFilter &&

        <ToggleSlider

          list = {[ "актуальные", "архивные" ]}
          selected = { balkons_filter_archieve }
          select = { ( v ) => { changeStates({ balkons_filter_archieve: v }) }}

        />

      }

      {/* <h2>Недавно сконструированы:</h2> */}

      { balkonsIsLoaded 
      
        ? balkons.length > 0
        
          ? balkons.map(( el, key ) => (

            <BalkonRow

              key = { key }
              id = { el.id }
              date = { el.date }
              price = { el.price }
              address = { el.address }
              image = { el.preview }
              client = { +user_role < 3 ? ( +el.user.id === +user_id ? "я замерял" : el.user.shortName ) : false }
              status = { el.status }
              windows_schema = { el.windows_schema }
              settings = { el.balkon }
              smeta = { el.smeta }
              action = { () => { balkon.open( el.id, openConstructor ) }}

            />

          ))
        
          : balkons_filter_archieve 
          
            ? "В архиве нет проектов" 
            : "Нет сохранённых балконов"
        
        : <Loading />
        
      }

      </TariffGate>

    </Container>

  );

}

export default Main;